import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'linear-gradient(180deg, #060d1a 0%, #030710 100%)' }}>
      {/* Gold top accent */}
      <div className="h-[3px]" style={{ background: 'linear-gradient(90deg, #c9a84c, #e8cc85, #c9a84c)' }} />

      {/* CTA strip */}
      <div className="border-b border-white/6">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-xl leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ready to Protect Your Future?
            </p>
            <p className="text-white/45 text-sm mt-1">Free consultation. No obligation. Same-day response available.</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3 flex-shrink-0">
            <a href="tel:9795300250"
              className="inline-flex items-center gap-2.5 px-7 py-3 border border-white/15 rounded-xl text-white text-sm font-semibold hover:border-[#c9a84c]/50 hover:text-[#c9a84c] transition-all cursor-pointer whitespace-nowrap">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-xs text-[#c9a84c]" />
              </div>
              (979) 530-0250
            </a>
            <Link to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-xl text-[#040810] text-sm font-bold transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #c9a84c, #dbb85a)' }}
            >
              Free Consultation
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">

          {/* Brand col */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block mb-6 cursor-pointer">
              <div className="flex flex-col leading-none">
                <span
                  className="text-[#c9a84c] font-black tracking-[0.18em] text-lg uppercase"
                  style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '0.2em' }}
                >
                  Bunger
                </span>
                <span
                  className="text-white font-semibold tracking-[0.3em] text-[11px] uppercase opacity-75"
                  style={{ letterSpacing: '0.3em' }}
                >
                  Law Firm, P.C.
                </span>
              </div>
            </Link>
            <p className="text-white/40 text-sm leading-relaxed mb-7 max-w-[280px]">
              Aggressive criminal defense representation for clients in Brenham, Texas and surrounding counties. Protecting your rights, record, and future.
            </p>

            {/* Stars */}
            <div className="flex items-center gap-1.5 mb-5">
              <div className="flex items-center gap-0.5">
                {[1,2,3,4,5].map(i => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#c9a84c] text-xs" />
                  </div>
                ))}
              </div>
              <span className="text-white/35 text-xs ml-1">5.0 · 50+ Google Reviews</span>
            </div>

            {/* Social links */}
            <div className="flex items-center gap-2.5">
              {[
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/bungerlawfirmpc' },
                { icon: 'ri-twitter-fill', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
              ].map((s) => (
                <a key={s.icon} href={s.href} target="_blank" rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-white/5 border border-white/8 rounded-xl hover:bg-[#c9a84c] hover:border-[#c9a84c] transition-all cursor-pointer">
                  <i className={`${s.icon} text-white text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h4 className="text-white font-bold text-sm mb-1">
              <a href="/" className="cursor-pointer hover:text-[#c9a84c] transition-colors">Navigation</a>
            </h4>
            <div className="w-7 h-[2px] bg-[#c9a84c] mb-5" />
            <ul className="space-y-2.5">
              {[
                { label: 'Home', to: '/' },
                { label: 'About Our Firm', to: '/about' },
                { label: 'Practice Areas', to: '/services/dui-defense' },
                { label: 'Service Areas', to: '/location/brenham' },
                { label: 'Contact Us', to: '/contact' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="flex items-center gap-2 text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer group">
                    <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-[#c9a84c]/40 text-xs group-hover:text-[#c9a84c] transition-colors" />
                    </div>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Practice Areas */}
          <div className="md:col-span-3">
            <h4 className="text-white font-bold text-sm mb-1">
              <a href="/services/dui-defense" className="cursor-pointer hover:text-[#c9a84c] transition-colors">Practice Areas</a>
            </h4>
            <div className="w-7 h-[2px] bg-[#c9a84c] mb-5" />
            <ul className="space-y-2.5">
              {[
                { label: 'DUI Defense', to: '/services/dui-defense' },
                { label: 'Drug Charges', to: '/services/drug-charges' },
                { label: 'Domestic Violence', to: '/services/domestic-violence' },
                { label: 'Assault & Violent Crimes', to: '/services/assault' },
                { label: 'Theft & Property Crimes', to: '/services/theft' },
                { label: 'White Collar Crimes', to: '/services/white-collar' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="flex items-center gap-2 text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer group">
                    <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-[#c9a84c]/40 text-xs group-hover:text-[#c9a84c] transition-colors" />
                    </div>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div className="md:col-span-3">
            <h4 className="text-white font-bold text-sm mb-1">
              <a href="/contact" className="cursor-pointer hover:text-[#c9a84c] transition-colors">Contact Information</a>
            </h4>
            <div className="w-7 h-[2px] bg-[#c9a84c] mb-5" />
            <ul className="space-y-4">
              {[
                { icon: 'ri-map-pin-2-fill', text: '105 W. Alamo Street\nBrenham, Texas 77833', href: null },
                { icon: 'ri-phone-fill', text: '(979) 530-0250', href: 'tel:9795300250' },
                { icon: 'ri-mail-fill', text: 'info@bungerlaw.com', href: 'mailto:info@bungerlaw.com' },
                { icon: 'ri-time-fill', text: 'Mon–Fri: 9:00am–5:00pm', href: null },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/5 border border-white/7 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#c9a84c] text-sm`} />
                  </div>
                  {item.href ? (
                    <a href={item.href} className="text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer leading-relaxed whitespace-pre-line">
                      {item.text}
                    </a>
                  ) : (
                    <p className="text-white/40 text-sm leading-relaxed whitespace-pre-line">{item.text}</p>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs">
            2026 © The Bunger Law Firm, P.C. All Rights Reserved. Brenham, Texas.
          </p>
          <div className="flex items-center gap-5">
            {['Privacy Policy', 'Terms of Use', 'Disclaimer'].map((label) => (
              <a key={label} href="#" className="text-white/20 text-xs hover:text-white/45 transition-colors cursor-pointer">
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
